
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {getCurrentSite} from 'redux/modules/currentUser/selectors'
import {editSiteInternalWhitelistRegexes} from 'redux/modules/sites/actions'
import AddDomainForm from './AddDomainForm'
import EditDomainForm from './EditDomainForm'

export class SettingsDomainView extends React.Component {
  static propTypes = {
    currentSite: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    editSiteInternalWhitelistRegexes: PropTypes.func
  }

  render() {
    const {currentSite, editSiteInternalWhitelistRegexes} = this.props
    const internalWhitelistRegexes = currentSite.internalWhitelistRegexes
      ? [...currentSite.internalWhitelistRegexes]
      : []

    return (
      <div className='settings-categories-view container'>
        <div className='settings-categories-view_mappings'>
          <AddDomainForm
            siteId={currentSite.id}
            internalWhitelistRegexes={internalWhitelistRegexes}
          />
          <EditDomainForm
            internalWhitelistRegexes={internalWhitelistRegexes}
            onRemoveRegexes={regexes => {
              const data = internalWhitelistRegexes?.filter(el => {
                return regexes.indexOf(el) < 0
              })

              editSiteInternalWhitelistRegexes({
                id: currentSite.id,
                internalWhitelistRegexes: data
              })
            }}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  currentSite: getCurrentSite(state)
})

export default connect(mapStateToProps, {editSiteInternalWhitelistRegexes})(
  SettingsDomainView
)



// WEBPACK FOOTER //
// ./client/views/SettingsDomainView/index.js